import { render, staticRenderFns } from "./DataAuthorization.vue?vue&type=template&id=62995cae"
import script from "./DataAuthorization.vue?vue&type=script&lang=js"
export * from "./DataAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports